<template>
  <div class="pageOverflow">
    <div class="commonInfo">
      <div class="newContent" style="display: flex;">
        <h3>
          <div style="display: block;margin: 0 auto;width: fit-content;">
            <div style="float: left;">
              <label>{{ cashBoxTotal ? cashBoxTotal : '0.00' }}</label>
              <small>钱箱现金总额（元）</small>
            </div>
            <el-button style="margin: 8px 0 8px 15px;" type="primary" size="small" @click="withdrawCash">提现</el-button>
          </div>
        </h3>
        <el-dialog class="newContentDialog" title="提现" :visible.sync="dialogFormVisible" width="640px" :append-to-body="true">
          <el-dialog title="提现" :visible.sync="innerVisible" width="505px" :append-to-body="true" @close="clearBusinessLimit">
            <div style="text-align: center;">
              <p class="need-to-pay">
                提现金额：
                <span style="color:#ff4949;font-size:18px;" v-text="'¥'+form.money"></span>
              </p>
              <p class="need-to-pay">方式：授权提现</p>
              <p>
                <img :src="getWxQRcode" alt="" style="height: 280px;widht:280px">
              </p>
              <p>请管理员扫码授权进行提现</p>
            </div>
          </el-dialog>
          <el-form ref="form" :model="form" :rules="rules">
            <el-form-item label="资金总额：" :label-width="formLabelWidth">
              <span style="font-size: 20px;font-weight: normal;font-stretch: normal;color: #409eff;" v-text="'￥'+cashBoxTotal"></span>
            </el-form-item>
            <el-form-item label="提现金额：" prop="money" :label-width="formLabelWidth">
              <el-input v-model.trim="form.money" placeholder="请输入提现金额" auto-complete="off" type="number" style="width:60%;margin-right: 10px;" @keyup.enter.native="Lib.keyboardBlur">
                <template slot="prepend">￥</template>
              </el-input>
              <el-button type="primary" @click="form.money=cashBoxTotal">全部提现</el-button>
            </el-form-item>
            <el-form-item label="备注：" :label-width="formLabelWidth">
              <el-input v-model="form.remark" style="width: 388px;" type="textarea" :rows="2" placeholder="请输入备注内容" maxlength="100"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="resetForm('form')">取 消</el-button>
            <el-button type="primary" :loading="loading1" @click="submitForm('form')">确定</el-button>
          </div>
        </el-dialog>
        <h3>
          <label>{{ currentIncomeTotal ? currentIncomeTotal : '0.00' }}</label>
          <small>今日现金收入总额（元）</small>
        </h3>
        <h3>
          <label>{{ currentDrawTotal ? currentDrawTotal : '0.00' }}</label>
          <small>今日现金提现总额（元）</small>
        </h3>
      </div>
    </div>
    <el-tabs v-model="activeName" style="margin-top: 10px;" @tab-click="handleClick">
      <el-tab-pane label="钱箱收入记录" name="first">
        <div class="margin-top" style="margin-top:10px;">
          <el-input v-model.trim="searchVal" style="width: 220px;" placeholder="请输入顾客姓名/会员卡号" @keyup.enter.native="selectIncomeCashPage('input')">
            <i slot="suffix" class="el-input__icon el-icon-search" style="cursor: pointer;" @click="selectIncomeCashPage('input')"></i>
          </el-input>
          <span style="padding-left: 20px;">时间筛选：</span>
          <yz-daterange @dateRange="getChooseTime2"></yz-daterange>
        </div>
        <div class="margin-top" style="margin:20px 0 43px 0;">
          <el-table v-loading="loadingOne" tooltip-effect="light" :data="tableData2">
            <el-table-column prop="payTime" label="订单时间">
            </el-table-column>
            <el-table-column prop="memberName" label="姓名">
              <template slot-scope="scope">{{ scope.row.memberName||'--' }}</template>
            </el-table-column>
            <el-table-column prop="memberCardNo" label="会员卡号">
              <template slot-scope="scope">{{ scope.row.memberCardNo||'--' }}</template>
            </el-table-column>
            <el-table-column prop="amount" label="消费金额">
              <template slot-scope="scope">{{ scope.row.amount||'--' }}</template>
            </el-table-column>
            <el-table-column label="支付方式">
              <template slot-scope="scope">
                {{ scope.row.orderType ? '现金' : '现金' }}
              </template>
            </el-table-column>
            <el-table-column prop="orderType" label="收入来源">
              <template slot-scope="scope">
                <span v-if="scope.row.orderType == 10">服务开单</span>
                <span v-else-if="scope.row.orderType == 20">快捷零售</span>
                <span v-else-if="scope.row.orderType == 31">套餐购买</span>
                <span v-else-if="scope.row.orderType == 32">套餐充值</span>
                <span v-else-if="scope.row.orderType == 40">套餐购买pc</span>
                <span v-else-if="scope.row.orderType == 41">套餐购买粉丝端</span>
                <span v-else-if="scope.row.orderType == 50">赊账还款</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="tableData2.length!=0" class="allFooter">
          <el-pagination background :current-page.sync="pageNum2" :page-sizes="[5, 10, 15, 20, 30, 40, 50]" :page-size="pageSize2" layout="total, sizes, prev, pager, next, jumper" :total="total2" @size-change="handleSizeChange2" @current-change="handleCurrentChange2">
          </el-pagination>
          <i class="iconfont backTop" @click="Lib.backTop()">&#xe62f;</i>
        </div>
      </el-tab-pane>
      <el-tab-pane label="钱箱提现记录" name="second">
        <div class="margin-top" style="margin-top:10px;">
          <span>时间筛选：</span>
          <yz-daterange @dateRange="getChooseTime"></yz-daterange>
        </div>
        <div class="margin-top" style="margin:20px 0 43px 0;">
          <el-table v-loading="loadingTwo" :data="tableData" tooltip-effect="light">
            <el-table-column prop="createTimeStr" label="提现时间" width="180">
            </el-table-column>
            <el-table-column prop="dutyName" label="操作人">
              <template slot-scope="scope">{{ scope.row.dutyName||'--' }}</template>
            </el-table-column>
            <el-table-column prop="memberName" label="授权人">
              <template slot-scope="scope">{{ scope.row.memberName||'--' }}</template>
            </el-table-column>
            <el-table-column prop="money" label="提现金额（元）">
            </el-table-column>
            <el-table-column prop="balance" label="钱箱余额（元）">
            </el-table-column>
            <el-table-column prop="remark" label="备注" :show-overflow-tooltip="true">
              <template slot-scope="scope">{{ scope.row.remark||'--' }}</template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="tableData.length!=0" class="allFooter">
          <el-pagination background :current-page.sync="pageNum" :page-sizes="[5, 10, 15, 20, 30, 40, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange">
          </el-pagination>
          <i class="iconfont backTop" @click="Lib.backTop()">&#xe62f;</i>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import {
  selectDrawCashPage,
  selectCashBoxSum,
  obtainGainQRCode,
  businessLimit,
  selectIncomeCashPage,
  saveDrawCash
} from './api';

export default {
  data() {
    const validateMoney = (rule, value, callback) => {
      if (value > this.cashBoxTotal) {
        this.form.money = this.cashBoxTotal;
        callback();
      } else if (value === '' || !Number(value) || value < 0) {
        callback(new Error('提现金额不能小于0'));
      } else {
        callback();
      }
    };
    return {
      value: '',
      tableData: [],
      searchParams: {
        startDate: '',
        endDate: '',
        pageNum: '1'
      },
      pageNum: 1,
      pageSize: 15, // 每页数据量
      total: 1,
      cashBoxTotal: '0.00', // 钱箱现金总额
      currentIncomeTotal: '0.00', // 今日现金收入总额
      currentDrawTotal: '0.00', // 今日现金提现总额
      // 提现
      dialogFormVisible: false,
      innerVisible: false,
      form: {
        money: '',
        remark: ''
      },
      rules: {
        money: [{ required: true, validator: validateMoney, trigger: 'change' }]
      },
      getWxQRcode: '',
      orderCode: '',
      businessLimitTime: null,
      formLabelWidth: '120px',
      loading1: false,

      activeName: 'first',
      value2: '',
      searchVal: '',
      tableData2: [],
      pageNum2: 1,
      pageSize2: 15, // 每页数据量
      total2: '',

      /* 5.2 */
      cashAuth: 0, // 授权权限控制  0需要授权，1不用授权直接提现
      // 5.7
      loadingOne: true,
      loadingTwo: true,
    };
  },
  activated() {
    this.handleClick();
  },
  methods: {
    // 得到子组件选择的时间--提现记录
    getChooseTime(time) {
      this.value = time;
      this.pageNum = 1;
      this.selectDrawCashPage();
    },
    // 得到子组件选择的时间--收入记录
    getChooseTime2(time) {
      this.value2 = time;
      this.pageNum2 = 1;
      this.selectIncomeCashPage();
    },
    // 切换记录列表
    handleClick() {
      this.selectCashBoxSum();
      if (this.activeName == 'first') {
        this.selectIncomeCashPage();
      } else {
        this.selectDrawCashPage();
      }
    },
    // 改变提现金额
    moneyChange() {
      // setTimeout(function () {
      //     if (this.form.money < 0 || !Number(this.form.money)) {
      //         this.form.money = 0
      //     } else {
      //         this.form.money = parseFloat(this.form.money).toFixed(2)
      //     }
      // }, 100)
    },
    selectDrawCashPage() {
      if (this.value) {
        const startDate = this.value[0];
        const endDate = this.value[1];
        this.searchParams = {
          startDate,
          endDate,
          pageSize: this.pageSize,
          pageNum: this.pageNum
        };
      } else {
        this.searchParams = {
          startDate: '',
          endDate: '',
          pageSize: this.pageSize,
          pageNum: this.pageNum
        };
      }
      this.loadingTwo = true;
      selectDrawCashPage(this.searchParams).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          // console.log(res)
        }
        this.loadingTwo = false;
      });
    },
    // 钱箱收入明细
    selectIncomeCashPage(val) {
      this.Lib.keyboardBlur();
      let data;
      if (val === 'input') {
        this.pageNum2 = 1;
      }
      if (this.value2) {
        const startDate = this.value2[0];
        const endDate = this.value2[1];
        data = {
          startDate,
          endDate,
          pageSize: this.pageSize2,
          pageNum: this.pageNum2,
          keyWord: this.searchVal ? this.searchVal : ''
        };
      } else {
        data = {
          startDate: '',
          endDate: '',
          pageSize: this.pageSize2,
          pageNum: this.pageNum2,
          keyWord: this.searchVal ? this.searchVal : ''
        };
      }
      this.loadingOne = true;
      selectIncomeCashPage(data).then((res) => {
        if (res.code === 0) {
          this.tableData2 = res.data.records ? res.data.records : [];
          this.total2 = res.data.total;
        } else {
          // console.log(res)
        }
        this.loadingOne = false;
      });
    },
    handleCurrentChange2(val) {
      this.pageNum2 = val;
      this.selectIncomeCashPage();
    },
    handleSizeChange2(val) {
      this.pageSize2 = val;
      this.pageNum2 = 1;
      this.selectIncomeCashPage();
    },
    handleCurrentChange() {
      this.selectDrawCashPage();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.selectDrawCashPage();
    },
    selectCashBoxSum() {
      selectCashBoxSum().then((res) => {
        if (res.code === 0) {
          this.cashBoxTotal = res.data.cashBoxTotal ? res.data.cashBoxTotal : '0.00';
          this.currentDrawTotal = res.data.currentDrawTotal ? res.data.currentDrawTotal : '0.00';
          this.currentIncomeTotal = res.data.currentIncomeTotal ? res.data.currentIncomeTotal : '0.00';
          this.cashAuth = res.data.cashAuth;
        }
      });
    },
    // 提现
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.cashAuth == 1) {
            saveDrawCash({
              remark: this.form.remark,
              money: this.form.money
            }).then((res) => {
              if (res.code === 0) {
                this.innerVisible = false;
                this.dialogFormVisible = false;
                this.form.money = '';
                this.form.remark = '';
                this.$refs[formName].resetFields();
                this.selectDrawCashPage();
                this.selectCashBoxSum();
                this.$message({
                  message: '成功',
                  type: 'success'
                });
              }
            });
          } else {
            obtainGainQRCode({
              money: this.form.money,
              remark: this.form.remark
            }).then((res) => {
              if (res.code === 0) {
                this.getWxQRcode = res.data.url;
                this.orderCode = res.data.orderCode;
                this.businessLimit(res.data.orderCode);
                this.innerVisible = true;
              }
            });
          }
        } else {
          // console.log("error submit!!");
          return false;
        }
      });
    },
    withdrawCash() {
      this.form.money = '';
      this.form.remark = '';
      this.dialogFormVisible = true;
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
      this.innerVisible = false;
    },
    businessLimit(orderCode) {
      this.businessLimitTime = null;
      this.businessLimitTime = setInterval(() => {
        businessLimit({ orderCode }).then((res) => {
          if (res.code == 0) {
            if (res.data == 1) {
              this.$message({
                message: '成功',
                type: 'success',
                onClose: () => {
                  this.innerVisible = false;
                  this.dialogFormVisible = false;
                  this.form.money = '';
                  this.form.remark = '';
                  this.selectDrawCashPage();
                  this.selectCashBoxSum();
                }
              });
              clearInterval(this.businessLimitTime);
            } else if (res.data == -1) {
              this.innerVisible = false;
              this.$message.error('过期');
              clearInterval(this.businessLimitTime);
            }
          } else {
            clearInterval(this.businessLimitTime);
          }
        });
      }, 1000);
    },
    clearBusinessLimit() {
      clearInterval(this.businessLimitTime);
    }
  }
};
</script>

<style>
.color {
    color: #409eff;
}
.pageOverflow {
    font-size: 14px;
}
.table-title {
    border-bottom: 1px solid #e4e7ed;
    padding-bottom: 10px;
    font-weight: 700;
}
.margin-top {
    margin-top: 30px;
}
.width {
    width: 330px;
}
.c333 {
    color: #333333;
}
.newContentDialog .el-dialog {
    min-height: 320px !important;
}
.newContentDialog .el-dialog__footer {
    padding: 0 20px 20px 0;
}
</style>

<style lang="less" scoped>
.need-to-pay {
    width: 228px;
    margin: 0 auto;
    text-indent: 15px;
    text-align: left;
    color: #333333;
    font-size: 14px;
    &:first-child {
        margin-bottom: 10px;
    }
}
</style>
